<template>
  <div>
    <span class="title bolder">기관 선택: </span>
    <select  v-model="select" @change="onSelect" class="select-underline">
      <option disabled>훈련 기관 선택</option>
      <option v-for="(o, i) in orgs" :key="i" :value="o">
        {{o.name}}
      </option>
    </select>
  </div>
</template>
<script>
import { } from 'mdbvue';
import Org from '@/models/Org'
import { mapMutations } from 'vuex';
export default {
  name: 'AdminOrgSelect',
  components: { },
  props: ['value'],
  data: function () {
    return {
      select: this.value,
      orgs: []
    }
  },
  methods: {
    ...mapMutations('auth', ['setOrg']),
    onSelect () {
      this.$emit('input', this.select)
      this.setOrg(this.select)
    }
  },
  async created () {
    this.orgs = await Org.list()
    if (this.value && this.value._id) {
      this.select = this.orgs.find(o => o._id === this.value._id)
    }
  }
}
</script>
<style scoped>

</style>
